export default __webpack_public_path__ + "static/media/placeholder_business06-en-web.b79db0a1.png";